
<template>
  <div class="login">
    <v-card style="padding: 20px" class="mx-auto mt-5">
      <v-card-title>
        <h2 style="color:darkgreen;">Stats</h2>
      </v-card-title>

      <div style="width: 100%; margin-bottom: 15px">
        <br>
        <input type="checkbox" style="width:25px;height:25px;" v-model="showLinks"  @change="loadStatus()">
        <span class="label14" style="margin:0 0 0 7px;">
              Show URI
        </span>
        <span style="display: inline-block; margin-left: 20px"></span>
        <span class="label16">Order By: </span>
        <select class="dropdown" v-model="orderBy" @change="onchange()">
          <option value="NAME">Name</option>
          <option value="HITS">Hits</option>
          <option value="DATE_ASC">Date Ascending</option>
          <option value="DATE_DESC">Date Descending</option>
        </select>
      </div>

      <v-card-text>
        <v-simple-table class="simple-table">
          <tr>
            <th width="7px">#</th>
            <th width="10px">Hits</th>
            <th width="180px">Last Access</th>
            <th>URI</th>
          </tr>
          <tr v-for="(stat, index) in stats" :key="stat">
            <td>{{index+1}}</td>
            <td>{{stat.counter}}</td>
            <td>{{printDateTime(stat.lastAccess)}}</td>
            <td>{{stat.uri}} {{getName(stat)}}</td>
          </tr>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';

  export default {
    name: "login",
    data: () => ({
      stats: [],
      showLinks: false,
      orderBy: "NAME"
    }),
    mounted: function() {
      this.loadStatus();
    },
    methods: {
      printDateTime(date) {
        return moment(date).format('MMM DD YYYY hh:mm A');
      },
      getName(stat) {
        if (stat.firstName !== null && stat.firstName !== '') {
          return ' - ' + stat.firstName + ' '
            + this.$AuthSvc.firstChar(stat.middleName) + ' '
            + stat.lastName;
        }

        return '';
      },
      loadStatus() {
        var _this = this;
        _this.axios.get('/admin/stats')
            .then(function (response) {
              _this.stats = new Array();
              response.data.forEach(function(stat) {
                if (stat.uri.startsWith("/")) {
                  if (_this.showLinks) {
                    _this.stats.push(stat);
                  }
                }
                else {
                  _this.stats.push(stat);
                }
              });
            })
            .catch(function (error) {
              console.log('ERROR: ' + error);
            });
      },
      onchange() {
        if (this.orderBy === 'NAME') {
          this.stats.sort((a, b) => {
            if ( a.uri < b.uri ) {
              return -1;
            }
            else {
              return 1;
            }
          });
        }
        else if (this.orderBy === 'HITS') {
          this.stats.sort((a, b) => {
            if ( a.counter > b.counter ) {
              return -1;
            }
            else {
              return 1;
            }
          });
        }
        else if (this.orderBy === 'DATE_ASC') {
          this.stats.sort((a, b) => {
            let x = moment(a.lastAccess).valueOf();
            let y = moment(b.lastAccess).valueOf();
            if ( x < y ) {
              return -1;
            }
            else {
              return 1;
            }
          });
        }
        else if (this.orderBy === 'DATE_DESC') {
          this.stats.sort((a, b) => {
            let x = moment(a.lastAccess).valueOf();
            let y = moment(b.lastAccess).valueOf();
            if ( x > y ) {
              return -1;
            }
            else {
              return 1;
            }
          });
          this.stats.sort((a, b) => {
            let x = moment(a.lastAccess).valueOf();
            let y = moment(b.lastAccess).valueOf();
            if ( x > y ) {
              return -1;
            }
            else {
              return 1;
            }
          });
          this.stats.sort((a, b) => {
            let x = moment(a.lastAccess).valueOf();
            let y = moment(b.lastAccess).valueOf();
            if ( x > y ) {
              return -1;
            }
            else {
              return 1;
            }
          });
        }
      }
    }
  }
</script>

<style scoped>

  th, td {
    text-align: left;
    border: 1px solid black;
  }

  .dropdown {
    color: white;
  }

  @media (min-width: 768px) {

  }

</style>